import { Image, Link, useCart } from '@shopify/hydrogen'
import { useContext, useEffect, useRef, useState } from 'react'
import styles from '../../assets/scss/components/header/header.module.scss'
import { BreakpointsContext } from '../layout/breakpoints-provider.client'
import { classNames } from '@shopify/css-utilities'
import { HeaderContext } from './header-provider.client'
import { useI18n } from '../i18n.client'
import { motion } from 'framer-motion'
import { useTracking } from '../../lib/hooks/tracking.client'

export const Header: React.FC<{
  isCartDrawerDisabled: boolean
  isInitiallyOpaque: boolean
  isSearchFormDisabled: boolean
  variant?: string
}> = ({ isCartDrawerDisabled, isInitiallyOpaque, isSearchFormDisabled, variant }) => {
  const [i18n] = useI18n()
  const { totalQuantity } = useCart()
  const { isMediumUp } = useContext(BreakpointsContext)
  const { notificationBarBoundingClientRect, setIsCartDrawerOpen } = useContext(HeaderContext)
  const [isLoaded, setIsLoaded] = useState(false)
  const ref = useRef<HTMLImageElement>(null)
  const { trackEvent } = useTracking()

  const handleClickCartIcon = () => {
    trackEvent('view_cart')
    setIsCartDrawerOpen(true)
  }

  const handleClickSearchIcon = () => {
    trackEvent('search_query')
  }

  useEffect(() => {
    if (ref.current) {
      setIsLoaded(ref.current.complete)
    }
  }, [ref])

  if (isMediumUp === undefined) {
    return null
  }

  return (
    <motion.header
      initial={{ opacity: isInitiallyOpaque ? 0 : 1 }}
      animate={{ opacity: isLoaded || !isInitiallyOpaque ? 1 : 0 }}
      className={classNames(styles.header, variant && styles[variant])}
      style={{
        paddingTop: notificationBarBoundingClientRect?.height ? notificationBarBoundingClientRect?.height + 10 : 14,
      }}>
      <div className="section">
        <Link className={styles.logoLink} to="/">
          <img
            alt="Marie Lichtenberg"
            decoding="async"
            height={20}
            loading="lazy"
            onLoad={() => setIsLoaded(true)}
            ref={ref}
            src={`/marie-lichtenberg-logotype-${isMediumUp ? 'large' : 'small'}.svg`}
            width={isMediumUp ? 426 : 86}
          />
        </Link>
        <div className={styles.icons}>
          <Link
            className={classNames(styles.search, isSearchFormDisabled && styles.disabled)}
            onClick={handleClickSearchIcon}
            to="/search">
            <Image alt={i18n.translate('search')} height={34} src="/search-closed-icon.svg" width={34} />
          </Link>
          <Link to="/account">
            <Image alt={i18n.translate('account')} height={34} src="/account-icon.svg" width={39} />
          </Link>
          <div
            className={classNames(styles.cart, (!totalQuantity || isCartDrawerDisabled) && styles.disabled)}
            onClick={handleClickCartIcon}>
            {totalQuantity}
          </div>
        </div>
      </div>
    </motion.header>
  )
}
